// Enhanced confetti and sparkle effects utility
// Extracted from SalesPage.js for reuse across the app

export const createEnhancedSparkleEffect = () => {
  const effects = [
    // Confetti
    { type: 'confetti', count: 100 },
    // Sparkles
    { type: 'sparkle', count: 50 },
    // Stars
    { type: 'star', count: 30 }
  ];

  effects.forEach(({ type, count }) => {
    for (let i = 0; i < count; i++) {
      setTimeout(() => {
        createParticle(type);
      }, i * 20);
    }
  });
};

const createParticle = (type) => {
  const particle = document.createElement('div');
  const colors = ['#FFD700', '#FF69B4', '#00FFFF', '#98FB98', '#DDA0DD', '#F0E68C', '#FF6B6B', '#4285f4'];
  
  // Base styles
  particle.style.position = 'fixed';
  particle.style.pointerEvents = 'none';
  particle.style.zIndex = '10000';
  particle.style.left = Math.random() * 100 + 'vw';
  particle.style.top = '-20px';
  
  if (type === 'confetti') {
    particle.style.width = '10px';
    particle.style.height = '10px';
    particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    particle.style.borderRadius = '50%';
    particle.style.animation = `confettiFall ${2 + Math.random() * 3}s linear forwards`;
  } else if (type === 'sparkle') {
    particle.innerHTML = '✨';
    particle.style.fontSize = '20px';
    particle.style.animation = `sparkleFall ${3 + Math.random() * 2}s linear forwards`;
  } else if (type === 'star') {
    particle.innerHTML = '⭐';
    particle.style.fontSize = '16px';
    particle.style.animation = `starFall ${4 + Math.random() * 2}s linear forwards`;
  }
  
  document.body.appendChild(particle);
  
  // Remove particle after animation
  setTimeout(() => {
    if (particle.parentNode) {
      particle.parentNode.removeChild(particle);
    }
  }, 6000);
};

// Add enhanced animations if they don't exist
export const addEnhancedAnimations = () => {
  if (!document.querySelector('#enhanced-effects-style')) {
    const style = document.createElement('style');
    style.id = 'enhanced-effects-style';
    style.textContent = `
      @keyframes confettiFall {
        to {
          transform: translateY(100vh) rotate(720deg);
          opacity: 0;
        }
      }
      @keyframes sparkleFall {
        0% {
          transform: translateY(0) scale(0) rotate(0deg);
          opacity: 1;
        }
        50% {
          transform: translateY(50vh) scale(1.5) rotate(180deg);
          opacity: 0.8;
        }
        100% {
          transform: translateY(100vh) scale(0) rotate(360deg);
          opacity: 0;
        }
      }
      @keyframes starFall {
        0% {
          transform: translateY(0) scale(0) rotate(0deg);
          opacity: 1;
        }
        25% {
          transform: translateY(25vh) scale(1.2) rotate(90deg);
          opacity: 1;
        }
        75% {
          transform: translateY(75vh) scale(1) rotate(270deg);
          opacity: 0.5;
        }
        100% {
          transform: translateY(100vh) scale(0) rotate(360deg);
          opacity: 0;
        }
      }
      
      .casino-pulse {
        animation: casinoPulse 0.6s ease-out;
      }
      
      @keyframes casinoPulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); box-shadow: 0 0 30px rgba(66, 133, 244, 0.8); }
        100% { transform: scale(1); }
      }
      
      .success-glow {
        animation: successGlow 1s ease-out;
      }
      
      @keyframes successGlow {
        0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7); }
        50% { box-shadow: 0 0 20px 10px rgba(34, 197, 94, 0.4); }
        100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
      }
    `;
    document.head.appendChild(style);
  }
}; 